import React from 'react'
import { Typography, Container } from '@mui/material'
import { useTranslation } from 'react-i18next'
import VoiceSettings from './VoiceSettings'
import PromptSettings from './PromptSettings'
import DebugSettings from './DebugSettings'
import SettingsArea from 'components/SettingsArea'
import SubSettingsArea from 'components/SubSettingsArea'
import TextSettings from './TextSettings'
import FitzgeraldCheckbox from './FitzgeraldCheckbox'
import MiscellaneousCheckbox from './MiscellaneousCheckbox'
import MiscellaneousUpperCaseCheckbox from './MiscellaneousUpperCaseCheckbox'
import { useAtom } from 'jotai'
import { useTheme } from '@mui/material/styles'
import {
  fitzgeraldBackgroundAtom,
  fitzgeraldFrameAtom,
  showMiscellaneousPictosAtom,
  miscellaneousUpperCaseAtom,
} from 'atoms'

// Atom to save the selected voices by language in localStorage

const Settings = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [fitzgeraldBackground, setFitzgeraldBackground] = useAtom(
    fitzgeraldBackgroundAtom
  )
  const [fitzgeraldFrame, setFitzgeraldFrame] = useAtom(fitzgeraldFrameAtom)
  const [showMiscellaneousPictos, setShowMiscellaneousPictos] = useAtom(
    showMiscellaneousPictosAtom
  )
  const [miscellaneousUpperCase, setMiscellaneousUpperCase] = useAtom(
    miscellaneousUpperCaseAtom
  )
  const toggleFitzgeraldBackground = () =>
    setFitzgeraldBackground(!fitzgeraldBackground)

  const toggleshowMiscellaneousPictos = () =>
    setShowMiscellaneousPictos(!showMiscellaneousPictos)

  const toggleMiscellaneousUpperCase = () =>
    setMiscellaneousUpperCase(!miscellaneousUpperCase)

  const toggleFitzgeraldFrame = () => setFitzgeraldFrame(!fitzgeraldFrame)

  return (
    <Container maxWidth="lg" sx={{ textAlign: 'left' }}>
      <Typography
        sx={{ mt: 4, color: theme.palette.primary.main }}
        variant="h1"
      >
        {t('settings')}
      </Typography>

      <SettingsArea text={t('pictograms')}>
        <Typography variant="body1">{t('pictogramsSettings')}</Typography>
        <SubSettingsArea text={t('peopleAppearance')}>
          <p>Configurar piel y color de pelo</p>
        </SubSettingsArea>
        <SubSettingsArea text={t('text')}>
          <TextSettings />
        </SubSettingsArea>
        <SubSettingsArea text={t('frame')}>
          <FitzgeraldCheckbox
            value={fitzgeraldFrame}
            onClick={toggleFitzgeraldFrame}
          />
        </SubSettingsArea>
        <SubSettingsArea text={t('backgroundColor')}>
          <FitzgeraldCheckbox
            value={fitzgeraldBackground}
            onClick={toggleFitzgeraldBackground}
          />
        </SubSettingsArea>
      </SettingsArea>

      <SettingsArea text={t('sentence')}>
        <Typography variant="body1">{t('sentenceSettings')}</Typography>
        <SubSettingsArea text={t('wordTypes')}>
          <div>
            <MiscellaneousCheckbox
              value={showMiscellaneousPictos}
              onClick={toggleshowMiscellaneousPictos}
            />
          </div>
          <div>
            <MiscellaneousUpperCaseCheckbox
              value={miscellaneousUpperCase}
              onClick={toggleMiscellaneousUpperCase}
              disabled={!showMiscellaneousPictos}
            />
          </div>
        </SubSettingsArea>
        <SubSettingsArea text={t('display')}>
          <p>Aquí iría el tamaño de fuente, color y tipo.</p>
          <p> Mostrar en pantalla con los pictogramas SI/NO </p>
          <p> Mostrar al imprimir con los pictogramas SI/NO </p>
        </SubSettingsArea>
      </SettingsArea>

      <SettingsArea text={t('voice')}>
        <VoiceSettings />
      </SettingsArea>

      <SettingsArea text={t('development')}>
        <DebugSettings />
        <PromptSettings />
      </SettingsArea>
    </Container>
  )
}

export default Settings
